<template>
<v-list dense subheader>
  <v-subheader v-if='title'>
    <v-progress-circular
      v-if='loading'
      indeterminate
      :size='18' :width='2'
      color='amber' class='mr-2' >
    </v-progress-circular>
    {{title}}
  </v-subheader>
  <v-list-tile
    v-for='payment in payments'
    :key='payment.id'
    :disabled="deletingPayments.indexOf(payment.id) !== -1" >
    <v-list-tile-action v-if='withDelete' >
      <v-btn
        @click='deleteDialog = true; selectedPayment = payment'
        icon >
        <v-icon>delete</v-icon>
      </v-btn>
    </v-list-tile-action>
    <v-list-tile-content >
      <v-list-tile-title>
        {{ dateformat(payment.transaction_date) }}
        <template v-if='payment.method' > via {{payment.method}}</template>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if='payment.reference'>
        ref: {{ payment.reference }}
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action >
      {{ formatCurrency( payment.currency, payment.amount) }}
    </v-list-tile-action>
  </v-list-tile>
  <v-list-tile v-if='payments && payments.length === 0' >
    <v-list-tile-content>
      <v-list-tile-title>
        No payments found for this appointment
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>

  <v-dialog v-model="deleteDialog" :width="300" >
    <v-card>
      <v-card-title >
        Are you sure you want to delete this payment
      </v-card-title>
      <v-card-actions >
        <v-btn @click='deleteDialog = false' flat >Cancel</v-btn>
        <v-spacer ></v-spacer>
        <v-btn
          @click='deleteClicked'
          :loading='deleteLoading'
          color='error' >Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-list>
</template>

<script>
import {ACTIONS} from '@/store/constants'
import axios from 'axios'

export default {
  name: 'PaymentList',
  props: {
    title: { type: String },
    appointment: { type: Object },
    payments: { type: Array, default: () => { return [] } },
    withDelete: { type: Boolean, default: true },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      deleteDialog: false,
      deleteLoading: false,
      deleteReqId: 'delete-payment-req',
      selectedPayment: null,
      deletingPayments: [],
      req: {
        resource: 'invoiceguru.transactions'
      }
    }
  },
  computed: {
    deleteRequest () {
      return this.$store.getters.getRequestById(this.deleteReqId, true)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    }
  },
  watch: {
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.$emit('payment:deleted')
      }
      if (this.deleteRequestStatus >= 400) {
        window.alert('There was an error deleting this payment. Please try again')
      }
    }
    // deleteDialog () {
    //   if (this.deleteDialog === true) {
    //     this.getPayment()
    //   }
    // }
  },
  methods: {
    deleteClicked () {
      let vm = this
      vm.deleteLoading = true
      vm.deletePayment()
      window.setTimeout(() => {
        vm.deleteLoading = false
        vm.deleteDialog = false
      }, 1000)
    },
    getPayment () {
      // console.log(this.selectedPayment)
      this.req.resourceId = this.selectedPayment.transaction_id
      this.$request('get', this.req)
    },
    deletePayment () {
      let action = ACTIONS.ASSIGN_PAYMENT
      let paymentId = this.selectedPayment.id
      let payload = {
        transaction_id: this.selectedPayment.transaction_id,
        appointments: {
          remove: [this.appointment.id]
        }
      }
      this.deletingPayments.push(paymentId)

      let url = this.$invoiceguru.baseUrl + '/action/' + action + '/'
      // let options = {
      //   headers: this.$invoiceguru.headers
      // }
      let options = this.$invoiceguru.getOptions()
      axios.put(url, JSON.stringify(payload), options)
        .then((result) => {
          this.$emit('payment:deleted')
        }).catch(() => {
          window.alert('Unable to remove payment')
        })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// PaymentList.vue?2be43d87